var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "custom-cascader el-cascader",
      style: { minWidth: _vm.filterable ? "300px" : "250px" }
    },
    [
      _c(
        "el-popover",
        {
          attrs: {
            placement: "bottom",
            trigger: "click",
            "popper-class": "p-0 custom-cascader-popover__popper"
          },
          on: {
            hide: function($event) {
              _vm.search = ""
            },
            show: _vm.setFocus
          },
          scopedSlots: _vm._u([
            {
              key: "reference",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "cascader-input el-input el-input--suffix" },
                    [
                      _c("input", {
                        staticClass: "el-input__inner",
                        attrs: { type: "text", readonly: "readonly" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "el-input__suffix" }, [
                        _c("span", { staticClass: "el-input__suffix-inner" }, [
                          _c("i", {
                            staticClass: "el-input__icon el-icon-arrow-up",
                            class: { "is-reverse": _vm.panelDisplay }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "cascader-items" }, [
                        _vm.previewItems.length > 0
                          ? _c("div", { staticClass: "item p-1" }, [
                              _c("span", { staticClass: "item-txt pl-2" }, [
                                _vm._v(_vm._s(_vm.previewItems[0].label))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.previewItems.length > 1
                          ? _c("div", { staticClass: "item p-1" }, [
                              _c("span", { staticClass: "item-tag" }, [
                                _vm._v(
                                  "+" + _vm._s(_vm.previewItems.length - 1)
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.filterable
                          ? _c("div", { staticClass: "item-search ml-1" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.search,
                                    expression: "search"
                                  }
                                ],
                                ref: "search",
                                staticClass: "b-0",
                                attrs: { type: "text" },
                                domProps: { value: _vm.search },
                                on: {
                                  input: [
                                    function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.search = $event.target.value
                                    },
                                    _vm.filterOptions
                                  ],
                                  focus: _vm.forceOpenPanel
                                }
                              })
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.placeholder != "" && _vm.previewItems.length == 0
                          ? _c("div", { staticClass: "cascader-placeholder" }, [
                              _c("span", [_vm._v(_vm._s(_vm.placeholder))])
                            ])
                          : _vm._e()
                      ])
                    ]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.panelDisplay,
            callback: function($$v) {
              _vm.panelDisplay = $$v
            },
            expression: "panelDisplay"
          }
        },
        [
          !_vm.filtering
            ? _c("el-cascader-panel", {
                attrs: { options: _vm.options, props: _vm.props },
                on: { change: _vm.update },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var node = ref.node
                        var data = ref.data
                        return [
                          _c(
                            "div",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.cascaderClick(node, data)
                                }
                              }
                            },
                            [_vm._v(_vm._s(data.label))]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  4289065518
                ),
                model: {
                  value: _vm.selectedValues,
                  callback: function($$v) {
                    _vm.selectedValues = $$v
                  },
                  expression: "selectedValues"
                }
              })
            : _c("div", { staticClass: "cascader-suggestion" }, [
                _c(
                  "ul",
                  { staticClass: "py-2 m-0" },
                  _vm._l(_vm.suggestions, function(suggestion) {
                    return _c(
                      "li",
                      {
                        key: suggestion.value,
                        on: {
                          click: function($event) {
                            return _vm.updateSuggestion(suggestion.value)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "suggestion-item cpointer prelative wp-10",
                            class: [
                              _vm.isChecked(suggestion.value)
                                ? "blue semibold"
                                : ""
                            ]
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "suggestion-item-label" },
                              [_vm._v(_vm._s(suggestion.label))]
                            ),
                            _vm._v(" "),
                            _vm.isChecked(suggestion.value)
                              ? _c("i", {
                                  staticClass:
                                    "fright el-icon-check primary-50 semibold"
                                })
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  }),
                  0
                )
              ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }